import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import OneClickButton from '../../components/form/button';
import Form from '../../components/form/form';
import DualList from '../../components/pages/DualList';
import { PanelPage } from '../../components/pages/pages';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportTransportEquipment extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          { I18n.t('BEE12' /* Início */)}
                </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1389' /* Cadastros */) },
      { value: I18n.t('BEE1396' /* Equipamentos */) },
      { value: I18n.t('BEE1397' /* Equipamentos de Transportes */), active: true },
    ];
    this.options = [
      {
        label: I18n.t('BEE82' /* Código */),
        value: 'code',
      }, {
        label: I18n.t('BEE277' /* Descrição */),
        value: 'note',
      }, {
        label: I18n.t('BEE1700' /* Marca */),
        value: 'brand',
      }, {
        label: I18n.t('BEE1701' /* Modelo */),
        value: 'model',
      }, {
        label: I18n.t('BEE1702' /* Número Patrimonial */),
        value: 'assetNumber',
      }, {
        label: I18n.t('BEE501' /* Número Série */),
        value: 'serialNumber',
      }, {
        label: I18n.t('BEE499' /* Ativo */),
        value: 'active',
      }, {
        label: I18n.t('BEE575' /* Usuário de criação */),
        value: 'createdUser',
      }, {
        label: I18n.t('BEE578' /* Data de criação */),
        value: 'createdAt',
      }, {
        label: I18n.t('BEE576' /* Usuário de alteração */),
        value: 'updatedUser',
      }, {
        label: I18n.t('BEE577' /* Data de alteração */),
        value: 'updatedAt',
      },
    ];
    this.state = {
      selected: [],
      codeTo: '',
      codeFrom: '',
      noteTo: '',
      noteFrom: '',
      brandTo: '',
      brandFrom: '',
      modelTo: '',
      modelFrom: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value, label) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      codeTo,
      codeFrom,
      noteTo,
      noteFrom,
      brandTo,
      brandFrom,
      modelTo,
      modelFrom,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));
    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['note', { type: 'between', value: [noteFrom, noteTo] }],
      ['brand', { type: 'between', value: [brandFrom, brandTo] }],
      ['model', { type: 'between', value: [modelFrom, modelTo] }],
    ]);
    this.props.generateReport(
      I18n.t('BEE1397' /* Equipamentos de Transportes */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      codeTo,
      codeFrom,
      noteTo,
      noteFrom,
      brandTo,
      brandFrom,
      modelTo,
      modelFrom,
    } = this.state;

    const { location = {} } = this.props;
    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE1397' /* Equipamentos de Transportes */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: codeFrom, to: codeTo },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE82' /* Código */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInputRange(
                    { from: noteFrom, to: noteTo },
                    { from: 'noteFrom', to: 'noteTo' },
                    `${I18n.t('BEE277' /* Descrição */)}:`,
                    { from: '', to: 'Z'.repeat(2000) },
                  ),
                  formContext.createInputRange(
                    { from: brandFrom, to: brandTo },
                    { from: 'brandFrom', to: 'brandTo' },
                    `${I18n.t('BEE1700' /* Marca */)}:`,
                    { from: '', to: 'Z'.repeat(150) },
                  ),
                  formContext.createInputRange(
                    { from: modelFrom, to: modelTo },
                    { from: 'modelFrom', to: 'modelTo' },
                    `${I18n.t('BEE1701' /* Modelo */)}:`,
                    { from: '', to: 'Z'.repeat(150) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
                )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
                )}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport: (nameDoc, type, route, columns, filters) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportTransportEquipment);
